import { useEffect, useState } from "react";
import { Layout } from "ui-components/Layout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitButton } from "ui-components/Form";
import { formRender, initialValues, divisionValidation } from "./division-schema";
import DivisionInfo from "./components/DivisionInfo";
import { useMutation } from "@tanstack/react-query";
import { Success, Error_ } from "ui-components/Alert";
import { addEditDivision } from "services/data.internal.service";
import { useLocation, useNavigate } from "react-router-dom";

function DivisionForm() {
  const [alert, setAlert] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const editData = location.state || null;
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const addEditMutation = useMutation(addEditDivision, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
      navigate("/division/list");
    },
    onError,
  });

  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(divisionValidation),
  });

  const { control, handleSubmit, formState: { errors }, reset } = form;

  useEffect(() => {
    if (!editData) return;
    let parsedCustomerCode = [];
    try {
      const parsed = JSON.parse(editData.customerCode);
      parsedCustomerCode = Array.isArray(parsed) ? parsed : [parsed];
    } catch {
      if (typeof editData.customerCode === "string") {
        parsedCustomerCode = editData.customerCode
          .split(",")
          .map((x) => x.trim())
          .filter((x) => x.length > 0);
      } else if (editData.customerCode) {
        parsedCustomerCode = [editData.customerCode];
      }
    }

    reset({
      ...editData,
      customerCode: parsedCustomerCode,
      originalDivisionGroup: editData.divisionGroup,
    });
  }, [editData, reset]);


  const onSubmit = (data) => {
    const customerCodes = Array.isArray(data.customerCode)
      ? data.customerCode
      : data.customerCode
      ? [data.customerCode]
      : [];
    addEditMutation.mutate({
      ...data,
      customerCode: JSON.stringify(customerCodes),
    });
  };

  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <DivisionInfo
          formRender={formRender}
          control={control}
          errors={errors}
          mode={editData ? "EDIT" : "ADD"}
        />
        <SubmitButton
          label={editData ? "Update" : "Submit"}
          disabled={addEditMutation.isLoading}
          url="/division/list"
        />
      </form>
    </Layout>
  );
}

export default DivisionForm;